export default "__VITE_ASSET__Dih51r97__"